import { useEffect, forwardRef, cloneElement, useState } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { useSpring, animated } from "@react-spring/web";
import { TextField } from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText";
import SelectInput from "./SelectInput";
import CustomizedButton from "./CustomizedButton";
import config from "../config";

const Fade = forwardRef(function Fade(props, ref) {
    const { children, in: open, onClick, onEnter, onExited, ownerState, ...other } = props;
    const style = useSpring({
        from: { opacity: 0 },
        to: { opacity: open ? 1 : 0 },
        onStart: () => {
            if (open && onEnter) {
                onEnter(null, true);
            }
        },
        onRest: () => {
            if (!open && onExited) {
                onExited(null, true);
            }
        },
    });

    return (
        <animated.div ref={ref} style={style} {...other}>
            {cloneElement(children, { onClick })}
        </animated.div>
    );
});

Fade.propTypes = {
    children: PropTypes.element.isRequired,
    in: PropTypes.bool,
    onClick: PropTypes.any,
    onEnter: PropTypes.func,
    onExited: PropTypes.func,
    ownerState: PropTypes.any,
};

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: "white",
    width: 600,
    height: 700,
    bgcolor: "black",
    border: "1px solid white",
    boxShadow: 24,
    p: 4,
    overflowY: "scroll",
};

const inputFormStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-end",
};

export default function SignUp({ openSignUp, signUpOpen, signUpClose }) {
    const [open, setOpen] = useState(openSignUp);

    const handleClose2 = () => {
        setOpen(false);
        signUpClose();
    };
    const [id, setId] = useState("");
    const [name, setName] = useState("");
    const [addr, setAddr] = useState("");
    const [tel, setTel] = useState("");
    const [pwCheck, setPwCheck] = useState("");
    const [password, setPassword] = useState("");
    const [ConfirmPassword, setConfirmPassword] = useState("");
    const [passwordQuestion, setPasswordQuestion] = useState("");

    const [idError, setIdError] = useState("");
    const [nameError, setNameError] = useState("");
    const [addrError, setAddrError] = useState("");
    const [pwCheckError, setPwCheckError] = useState("");
    const [telError, setTelError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [pwQError, setPwQError] = useState("");

    const emailInput = document.querySelector("[name=email]");
    const passwordInput2 = document.querySelector("[name=password2]");
    const passwordConfirmInput = document.querySelector("[name=passwordconfirm]");
    const nameInput = document.querySelector("[name=name]");
    const telInput = document.querySelector("[name=tel]");
    const addrInput = document.querySelector("[name=addr]");
    const pwQInput = document.querySelector("[name=pwQ]");
    const pwAInput = document.querySelector("[name=pwA]");

    const emailFocus = () => {
        emailInput.focus();
    };

    const passwordFocus = () => {
        passwordInput2.focus();
    };
    const passwordConfirmFocus = () => {
        passwordConfirmInput.focus();
    };

    const nameFocus = () => {
        nameInput.focus();
    };
    const telFocus = () => {
        telInput.focus();
    };

    const addrFocus = () => {
        addrInput.focus();
    };
    const pwQFocus = () => {
        pwQInput.focus();
    };

    const pwAFocus = () => {
        pwAInput.focus();
    };

    const gotoPasswordInput = (e) => {
        if (e.key === "Enter") {
            passwordFocus();
        }
    };
    const gotoPasswordConfirmInput = (e) => {
        if (e.key === "Enter") {
            passwordConfirmFocus();
        }
    };
    const gotoNameInput = (e) => {
        if (e.key === "Enter") {
            nameFocus();
        }
    };
    const gotoTelInput = (e) => {
        if (e.key === "Enter") {
            telFocus();
        }
    };
    const gotoAddrInput = (e) => {
        if (e.key === "Enter") {
            addrFocus();
        }
    };
    const gotoPwQInput = (e) => {
        if (e.key === "Enter") {
            pwQFocus();
        }
    };
    const gotoPwAInput = (e) => {
        if (e.key === "Enter") {
            pwAFocus();
        }
    };

    useEffect(() => {
        emailFocus();
    }, []);

    const onConfirmPasswordHandler = (event) => {
        setConfirmPassword(event.currentTarget.value);
    };

    const isValidId = (id) => {
        const idRegex =
            /([\w-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        return idRegex.test(id);
    };
    const isValidPassword = (password) => {
        const passwordRegex = password.length >= 4 && password.length <= 20;
        return passwordRegex;
    };
    const isValidatePhone = (tel) => {
        const phoneRegex = /^01(?:0|1|[6-9])-(?:\d{3}|\d{4})-\d{4}$/;
        return phoneRegex.test(tel.slice(0, 13));
    };

    const handleIdChange = (event) => {
        setId(event.target.value);
        setIdError(isValidId(event.target.value) ? "" : "Please enter a valid email address.");
        if (event.target.value === "") {
            setIdError("Please enter your email.");
        }
    };

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
        setPasswordError(isValidPassword(event.target.value) ? "" : "Password must be 4-20 characters.");
        if (event.target.value === "") {
            setPasswordError("Please enter your password.");
        }
    };

    const handleAddrChange = (event) => {
        setAddr(event.target.value);
        if (event.target.value !== "") {
            setAddrError("");
        } else {
            setAddrError("Please enter your address.");
        }
    };

    const handleNameChange = (event) => {
        setName(event.target.value);
        if (event.target.value !== "") {
            setNameError("");
        } else {
            setNameError("Please enter your name.");
        }
    };

    const handleTelChange = (event) => {
        setTel(
            event.target.value
                .replace(/[^0-9]/g, "")
                .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})(\d{0,1})$/g, "$1-$2-$3")
                .replace(/(\-{1,2})$/g, "")
                .slice(0, 13),
        );
        setTelError(isValidatePhone(event.target.value) ? "" : "Please enter a valid phone number.");
        if (event.target.value === "") {
            setTelError("Please enter your phone number.");
        }
    };
    const handlePwCheckChange = (event) => {
        setPwCheck(event.target.value);
        if (event.target.value !== "") {
            setPwCheckError("");
        } else {
            setPwCheckError("Please enter your security answer.");
        }
    };

    const loginCheck = (event) => {
        let check = true;
        if (password !== ConfirmPassword && password !== "") {
            alert("Passwords do not match.");
            check = false;
        }

        idDuplicateCheck();
        if (idError === "") {
            alert("Please check for duplicate email first.");
            check = false;
        } else if (idError === "This email is already in use.") {
            check = false;
        }

        let validId =
            /([\w-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/.test(
                id,
            );
        let validPassword = password.length >= 4 && password.length <= 20;
        let validTel = /^01(?:0|1|[6-9])-(?:\d{3}|\d{4})-\d{4}$/.test(tel.slice(0, 13));
        if (!id) {
            setIdError("Please enter your email.");
            check = false;
        } else if (!validId) {
            setIdError("Please enter a valid email address.");
            check = false;
        }
        if (!password) {
            setPasswordError("Please enter your password.");
            check = false;
        } else if (!validPassword) {
            setPasswordError("Password must be 4-20 characters.");
            check = false;
        }
        if (!name) {
            setNameError("Please enter your name.");
            check = false;
        } else {
            setNameError("");
        }
        if (!tel) {
            setTelError("Please enter your phone number.");
            check = false;
        } else if (!validTel) {
            setTelError("Please enter a valid phone number.");
            check = false;
        }
        if (!addr) {
            setAddrError("Please enter your address.");
            check = false;
        } else {
            setAddrError("");
        }
        if (!passwordQuestion) {
            setPwQError("Please select a security question.");
            check = false;
        } else {
            setPwQError("");
        }
        if (!pwCheck) {
            setPwCheckError("Please enter your security answer.");
            check = false;
        } else {
            setPwCheckError("");
        }
        return check;
    };

    const loginSubmit = (e) => {
        if (loginCheck()) {
            axios
                .post(`${config.API_URL}/insertMember`, {
                    member_id: id,
                    member_pw: password,
                    member_name: name,
                    member_tel: tel,
                    member_addr: addr,
                    pw_question: passwordQuestion,
                    pw_answer: pwCheck,
                })
                .then((res) => {
                    if (res.data === 1) {
                        alert("Sign up successful!");
                        handleClose2();
                    } else {
                        alert("Sign up failed!");
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        }
    };

    const idDuplicateCheck = () => {
        if (id !== "") {
            if (isValidId(id)) {
                axios
                    .post(`${config.API_URL}/idDuplicateCheck`, {
                        member_id: id,
                    })
                    .then((res) => {
                        if (res.data === 1) {
                            setIdError("This email is already in use.");
                            return false;
                        } else {
                            setIdError("This email is available.");
                            return true;
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            } else {
                setIdError("Please enter a valid email address.");
            }
        } else {
            setIdError("Please enter your email.");
        }
    };

    const checkenterSubmit = (e) => {
        if (e.key === "Enter") {
            loginSubmit();
        }
    };
    return (
        <div>
            <Modal
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description"
                open={open}
                onClose={handleClose2}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {},
                }}
            >
                <Fade in={open}>
                    <Box sx={style}>
                        <Typography
                            sx={{ width: "150px", mx: "auto", mb: 3 }}
                            id="spring-modal-title"
                            variant="h5"
                            component="h2"
                        >
                            Sign Up
                        </Typography>
                        <Box
                            sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "flex-end",
                                height: "73.6",
                                marginBottom: "5px",
                            }}
                        >
                            <Typography sx={{ width: "150px", mr: 5, mt: 3 }} variant="h10" component="h4">
                                Email Address
                            </Typography>
                            <div
                                style={{
                                    height: "57.6px",
                                    alignItems: "center",
                                    display: "flex",
                                }}
                            >
                                <TextField
                                    sx={{
                                        my: 1,
                                        width: "275px",
                                        color: "white",
                                        background: "#38393b",
                                        fontSize: "20px",
                                        borderRadius: 1,
                                        marginRight: "10px",
                                        height: "53px",
                                        "& .MuiOutlinedInput-root": {
                                            backgroundColor: "transparent",
                                            "& fieldset": {
                                                borderColor: "rgba(0, 0, 0, 0.23)",
                                            },
                                            "&.Mui-focused fieldset": {
                                                border: "2px solid white",
                                            },
                                        },
                                    }}
                                    name="email"
                                    onKeyPress={gotoPasswordInput}
                                    autoComplete="off"
                                    label="Enter your email address"
                                    type="email"
                                    value={id}
                                    onChange={handleIdChange}
                                    required
                                    inputProps={{ style: { color: "white" } }}
                                    InputLabelProps={{ style: { color: "white" } }}
                                />

                                <CustomizedButton
                                    label="Check"
                                    value="check"
                                    onClick={idDuplicateCheck}
                                ></CustomizedButton>
                            </div>
                            <FormHelperText sx={{ padding: "1px", color: "red" }}>{idError}</FormHelperText>
                        </Box>
                        <Box sx={inputFormStyle}>
                            <Typography sx={{ width: "150px", mr: 5, mt: 3 }} variant="h10" component="h4">
                                Password
                            </Typography>
                            <TextField
                                sx={{
                                    my: 1,
                                    width: "360px",
                                    color: "white",
                                    background: "#38393b",
                                    fontSize: "20px",
                                    borderRadius: 1,
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "transparent",
                                        "& fieldset": {
                                            borderColor: "rgba(0, 0, 0, 0.23)",
                                        },
                                        "&.Mui-focused fieldset": {
                                            border: "2px solid white",
                                        },
                                    },
                                }}
                                name="password2"
                                onKeyPress={gotoPasswordConfirmInput}
                                autoComplete="off"
                                label="Enter your password"
                                type="password"
                                value={password}
                                onChange={handlePasswordChange}
                                setPwQError={setPwQError}
                                passwordQuestion={passwordQuestion}
                                setPasswordQuestion={setPasswordQuestion}
                                required
                                inputProps={{ style: { color: "white" } }}
                                InputLabelProps={{ style: { color: "white" } }}
                            />
                            <FormHelperText sx={{ color: "red" }}>{passwordError}</FormHelperText>
                        </Box>
                        <Box sx={inputFormStyle}>
                            <Typography sx={{ width: "150px", mr: 5, mt: 3 }} variant="h10" component="h4">
                                Confirm Password
                            </Typography>
                            <TextField
                                sx={{
                                    my: 1,
                                    width: "360px",
                                    color: "white",
                                    background: "#38393b",
                                    fontSize: "20px",
                                    borderRadius: 1,
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "transparent",
                                        "& fieldset": {
                                            borderColor: "rgba(0, 0, 0, 0.23)",
                                        },
                                        "&.Mui-focused fieldset": {
                                            border: "2px solid white",
                                        },
                                    },
                                }}
                                name="passwordconfirm"
                                onKeyPress={gotoNameInput}
                                autoComplete="off"
                                required
                                inputProps={{ style: { color: "white" } }}
                                InputLabelProps={{ style: { color: "white" } }}
                                label="Confirm your password"
                                type="password"
                                value={ConfirmPassword}
                                onChange={onConfirmPasswordHandler}
                            />
                        </Box>
                        <Box sx={inputFormStyle}>
                            <Typography sx={{ width: "150px", mr: 5, mt: 3 }} variant="h10" component="h4">
                                Name
                            </Typography>
                            <TextField
                                sx={{
                                    my: 1,
                                    width: "360px",
                                    color: "white",
                                    background: "#38393b",
                                    fontSize: "20px",
                                    borderRadius: 1,
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "transparent",
                                        "& fieldset": {
                                            borderColor: "rgba(0, 0, 0, 0.23)",
                                        },
                                        "&.Mui-focused fieldset": {
                                            border: "2px solid white",
                                        },
                                    },
                                }}
                                name="name"
                                onKeyPress={gotoTelInput}
                                autoComplete="off"
                                label="Enter your name"
                                type="text"
                                value={name}
                                onChange={handleNameChange}
                                required
                                inputProps={{ style: { color: "white" } }}
                                InputLabelProps={{ style: { color: "white" } }}
                            />
                            <FormHelperText sx={{ color: "red" }}>{nameError}</FormHelperText>
                        </Box>
                        <Box sx={inputFormStyle}>
                            <Typography sx={{ width: "150px", mr: 5, mt: 3 }} variant="h10" component="h4">
                                Phone Number
                            </Typography>
                            <TextField
                                sx={{
                                    my: 1,
                                    width: "360px",
                                    color: "white",
                                    background: "#38393b",
                                    fontSize: "20px",
                                    borderRadius: 1,
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "transparent",
                                        "& fieldset": {
                                            borderColor: "rgba(0, 0, 0, 0.23)",
                                        },
                                        "&.Mui-focused fieldset": {
                                            border: "2px solid white",
                                        },
                                    },
                                }}
                                name="tel"
                                onKeyPress={gotoAddrInput}
                                autoComplete="off"
                                label="Enter your phone number"
                                required
                                inputProps={{ style: { color: "white" } }}
                                InputLabelProps={{ style: { color: "white" } }}
                                value={tel}
                                onChange={handleTelChange}
                            />
                            <FormHelperText sx={{ color: "red" }}>{telError}</FormHelperText>
                        </Box>
                        <Box sx={inputFormStyle}>
                            <Typography sx={{ width: "150px", mr: 5, mt: 3 }} variant="h10" component="h4">
                                Address
                            </Typography>
                            <TextField
                                sx={{
                                    my: 1,
                                    width: "360px",
                                    color: "white",
                                    background: "#38393b",
                                    fontSize: "20px",
                                    borderRadius: 1,
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "transparent",
                                        "& fieldset": {
                                            borderColor: "rgba(0, 0, 0, 0.23)",
                                        },
                                        "&.Mui-focused fieldset": {
                                            border: "2px solid white",
                                        },
                                    },
                                }}
                                name="addr"
                                onKeyPress={gotoPwQInput}
                                autoComplete="off"
                                label="Enter your address"
                                required
                                inputProps={{ style: { color: "white" } }}
                                InputLabelProps={{ style: { color: "white" } }}
                                value={addr}
                                onChange={handleAddrChange}
                            />

                            <FormHelperText sx={{ color: "red" }}>{addrError}</FormHelperText>
                        </Box>
                        <Box
                            sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "flex-end",
                            }}
                            style={{ alignItems: "center" }}
                        >
                            <Typography
                                sx={{
                                    width: "150px",
                                    mr: 5,
                                    height: "56px",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                                variant="h10"
                                component="h4"
                            >
                                Security Question
                            </Typography>
                            <SelectInput
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "transparent",
                                        "& fieldset": {
                                            borderColor: "rgba(0, 0, 0, 0.23)",
                                        },
                                        "&.Mui-focused fieldset": {
                                            border: "2px solid white",
                                        },
                                    },
                                }}
                                onKeyPress={gotoPwAInput}
                                autoComplete="off"
                                setPwQError={setPwQError}
                                passwordQuestion={passwordQuestion}
                                setPasswordQuestion={setPasswordQuestion}
                            />
                            <FormHelperText sx={{ color: "red" }}>{pwQError}</FormHelperText>
                        </Box>
                        <Box sx={inputFormStyle} style={{ alignItems: "center" }}>
                            <Typography sx={{ width: "150px", mr: 5 }} variant="h10" component="h4">
                                Security Answer
                            </Typography>

                            <TextField
                                sx={{
                                    my: 1,
                                    width: "360px",
                                    color: "white",
                                    background: "#38393b",
                                    fontSize: "20px",
                                    borderRadius: 1,
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "transparent",
                                        "& fieldset": {
                                            borderColor: "rgba(0, 0, 0, 0.23)",
                                        },
                                        "&.Mui-focused fieldset": {
                                            border: "2px solid white",
                                        },
                                    },
                                }}
                                name="pwA"
                                autoComplete="off"
                                label="Answer to the security question"
                                required
                                inputProps={{ style: { color: "white" } }}
                                InputLabelProps={{ style: { color: "white" } }}
                                value={pwCheck}
                                onChange={handlePwCheckChange}
                                onKeyPress={checkenterSubmit}
                            />
                            <FormHelperText sx={{ color: "red" }}>{pwCheckError}</FormHelperText>
                        </Box>
                        <Box sx={{ mx: "auto", width: 100, marginTop: "15px" }}>
                            <CustomizedButton label="Sign Up" onClick={loginSubmit}></CustomizedButton>
                        </Box>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
}
